/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangesNewPartNumberComponent} from './part-number-changes-new-part-number.component';
import {InputModule} from '../../../shared/input/input.module';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {StickyHeaderModule} from '../../../shared/sticky-header/sticky-header.module';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';
import {PartNumberChangesAdditionalInputModule} from '../../shared/part-number-changes-additional-input/part-number-changes-additional-input.module';

@NgModule({
    declarations: [PartNumberChangesNewPartNumberComponent],
    exports: [PartNumberChangesNewPartNumberComponent],
    imports: [
        CommonModule,
        InputModule,
        ClipboardModule,
        StickyHeaderModule,
        TooltipModule,
        PartNumberChangesAdditionalInputModule
    ]
})
export class PartNumberChangesNewPartNumberModule {
}
